import styled from 'styled-components';
import { motion } from 'framer-motion';
import { ReactComponent as ArrowIcon } from '../../assets/arrowRight.svg';
import { AnimatePresence } from 'framer-motion';

const LinkButton = ({ id = '', value = null, animate = false }) => {
  return (
    <Wrapper style={{ '--width': `${value && animate ? '84px' : '36px'}` }}>
      <CornerLink
        as={motion.div}
        layout={true}
        initial={false}
        animate={{ borderRadius: '36px' }}
        transition={{ duration: 0.4 }}
        exit={{ transition: { duration: 0.6 } }}
      >
        <AnimatePresence mode='wait'>
          {value && animate && (
            <LinkText
              key={id}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, ease: 'easeOut' }}
              exit={{ x: -30, opacity: 0, transition: { duration: 0.3 } }}
              as={motion.p}
              layout='position'
            >
              {value}
            </LinkText>
          )}
        </AnimatePresence>
        <IconWrapper
          as={motion.div}
          transition={{ duration: 0.4 }}
          layout='position'
        >
          <Icon />
        </IconWrapper>
      </CornerLink>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: var(--width);
  @media (max-width: 500px) {
    width: 36px;
  }
`;

const CornerLink = styled.div`
  background-color: hsl(0, 0%, 100%);
  height: 36px;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 8px;
  width: 100%;
  overflow: hidden;

  &:hover {
    cursor: pointer;
    transition: box-shadow 0.2s ease-out 0s;
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 1px,
      rgba(255, 255, 255, 0.5) 0px 0px 0px 6px;
  }

  @media (max-width: 500px) {
    height: 36px;
    width: var(--width);
  }
`;

const LinkText = styled.p`
  font-size: 1rem;
  position: absolute;
  top: 6px;
  left: 16px;
`;

const Icon = styled(ArrowIcon)`
  transform: rotate(-45deg);
  color: ${({ theme }) => theme.iconColor};
`;
const IconWrapper = styled.div`
  position: absolute;
  top: -3px;
  right: -4px;
  height: 40px;
  width: 40px;
`;

export default LinkButton;
